// Cataloagele statice ale structurii (verificări, pași, mărimi), în limba
// ecranului.
//
// Serverul le compune în limba profilului, iar getterii din `apiStructura`
// le țin minte pe (catalog, limbă). Hook-ul le re-cere când se schimbă limba;
// până sosește catalogul nou îl păstrează pe cel vechi — un hover în limba de
// adineauri e mai bun decât unul gol.

import { useEffect, useState } from "react";
import { useLimba } from "../i18n";
import type { CatalogMarimi, CatalogPasi, CatalogVerificari } from "./tipuri";
import { getCatalogMarimi, getCatalogPasi, getCatalogVerificari } from "./apiStructura";

// catalogul deja sosit, pe getter și limbă: o componentă montată mai târziu
// îl are din prima randare, fără clipirea «încă nu e»
const sosite = new Map<() => Promise<unknown>, Map<string, unknown>>();

export function useCatalog<T>(cere: () => Promise<T>): T | null {
  const l = useLimba();
  const [catalog, setCatalog] = useState<T | null>(
    () => (sosite.get(cere)?.get(l) as T | undefined) ?? null
  );
  useEffect(() => {
    let viu = true;
    cere()
      .then((c) => {
        if (!sosite.has(cere)) sosite.set(cere, new Map());
        sosite.get(cere)!.set(l, c);
        if (viu) setCatalog(c);
      })
      .catch(() => {});
    return () => {
      viu = false;
    };
  }, [cere, l]);
  return catalog;
}

export const useCatalogVerificari = () =>
  useCatalog<CatalogVerificari>(getCatalogVerificari);
export const useCatalogPasi = () => useCatalog<CatalogPasi>(getCatalogPasi);
export const useCatalogMarimi = () => useCatalog<CatalogMarimi>(getCatalogMarimi);
